import { Viewer, VERSION, events as CoreEvents, utils } from '@photo-sphere-viewer/core';
import { EquirectangularTilesAdapter } from '@photo-sphere-viewer/equirectangular-tiles-adapter';
import { MarkersPlugin, events as MarkerEvents } from '@photo-sphere-viewer/markers-plugin';
import { AutorotatePlugin, events as AutorotateEvents } from '@photo-sphere-viewer/autorotate-plugin';
import { VirtualTourPlugin, events as VirtualTourEvents } from '@photo-sphere-viewer/virtual-tour-plugin';

window.PhotoSphereViewer = Object.freeze({
  Viewer,
	Animation: utils.Animation,
  VERSION,
  CoreEvents,
  EquirectangularTilesAdapter,
  MarkersPlugin,
  MarkerEvents,
	AutorotatePlugin,
	AutorotateEvents,
	VirtualTourPlugin,
	VirtualTourEvents,
});
